import { useState, useEffect } from 'react';

import TopNavBar from '../components/TopNavBar';
import SideNavBar from '../components/SideNavBar';
import Refreshing from '../components/Refreshing';

import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  useSortable,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Our libraries
import * as logger from '../logger';
import * as apiComms from '../apiComms';

import * as dayjs from 'dayjs'

// components
import WebstoreLinkCardComponent from '../components/WebstoreLinkCardComponent';

import { IoMdSettings } from "react-icons/io";
import { FaTrashAlt } from "react-icons/fa";
import { MdOutlineAddPhotoAlternate } from "react-icons/md";
import { IoMdAddCircleOutline } from "react-icons/io";

import WebstoreLinkAddOrEditModal from '../modals/WebstoreLinkAddOrEditModal';
//import DeleteWebstoreLinkItemModal from '../modals/DeleteWebstoreLinkItemModal';
import DeletePromotionItemModal from '../modals/DeletePromotionItemModal';
import useIsMobile, { DESKTOP_CONTENT_MARGIN_LEFT, MOBILE_CONTENT_MARGIN_LEFT } from '../hooks/useIsMobile';

const PROG = 'WebstoreLinks.js';

const WebstoreLinks = (props) => {

  const [showInfoBox, setShowInfoBox] = useState(true);
  const [displayBannerLink, setDisplayBannerLink] = useState(null);
  const [displayWebstoreLinks, setDisplayWebstoreLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [isAddWebstoreLinkModalVisible, setIsAddWebstoreLinkModalVisible] = useState(false);
  const [isAddOrEditWebstoreLinkModalRefreshing, setIsAddOrEditWebstoreLinkModalRefreshing] = useState(false);
  const [editWebstoreLinkItem, setEditWebstoreLinkItem] = useState(null);
  const [isEditWebstoreLinkModalVisible, setIsEditWebstoreLinkModalVisible] = useState(false);
  const [deleteWebstoreLinkItem, setDeleteWebstoreLinkItem] = useState(null);
  const [isDeleteWebstoreLinkModalVisible, setIsDeleteWebstoreLinkModalVisible] = useState(false);

  const [isAddBannerModalVisible, setIsAddBannerModalVisible] = useState(false);
  const [isEditBannerModalVisible, setIsEditBannerModalVisible] = useState(false);
  const [editBannerItem, setEditBannerItem] = useState(null);
  const [deleteBannerLink, setDeleteBannerLink] = useState(null);
  const [isDeleteBannerLinkModalVisible, setIsDeleteBannerLinkModalVisible] = useState(false);
  const [isAddOrEditBannerModalRefreshing, setIsAddOrEditBannerModalRefreshing] = useState(false);
  const [isDeleteBannerModalRefreshing, setIsDeleteBannerModalRefreshing] = useState(false);

  const [isInfoToastVisible, setIsInfoToastVisible ] = useState(false);
  const [infoToastMessage, setInfoToastMessage ] = useState('');
  const isMobile = useIsMobile();

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5, // small drag threshold
      },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    //console.log('ACTIVE: '+JSON.stringify(active));
    //console.log('OVER: '+JSON.stringify(over));

    if (!over || active.id === over.id) {
      return;
    }

    if (active.id !== over.id) {
      const oldIndex = displayWebstoreLinks.findIndex((item) => item.linkId === active.id);
      console.log('OLD Index: '+oldIndex);
      const newIndex = displayWebstoreLinks.findIndex((item) => item.linkId === over.id);
      console.log('NEW Index: '+newIndex);
      const updatedRecords = arrayMove(displayWebstoreLinks, oldIndex, newIndex);
      // Update the 
      //setDisplayWebstoreLinks(updatedRecords);
      setDisplayWebstoreLinks(arrayMove(displayWebstoreLinks, oldIndex, newIndex));
      updateItemOrderInCloud(updatedRecords);
    }
  };

  const updateItemOrderInCloud = async (updatedRecords) => {
    const FUNCTION = 'updateItemOrderInCloud';

    // Show Info Toast
    setInfoToastMessage('Saving...');
    setIsInfoToastVisible(true);

    let updates = [];
    for (let i=0;i<updatedRecords.length;i++) {
      const webstoreLink = updatedRecords[i];
      const updateRec = {
        linkId : webstoreLink.linkId,
        orderId : i
      };
      updates.push(updateRec);
    }
    //alert('Updates: '+JSON.stringify(updates))

    const res = await apiComms.updateWebstoreLinkOrders(updates);
    logger.debug('updateWebstoreLinkOrders response', { PROG, FUNCTION, res });

    if (res.isErr) {
      // An error occured
      setInfoToastMessage('Error Occured: '+res.errMsg);
      setTimeout(() => {
        setIsInfoToastVisible(false);
      }, 2000);
      // Revert the order changes
      setDisplayWebstoreLinks((prevDisplayWebstoreLinks) =>
        [...prevDisplayWebstoreLinks].sort((a, b) => {
          const a_orderId = a.orderId;
          const b_orderId = b.orderId;
          if (a_orderId < b_orderId) {
            return -1;
          }
          else if (a_orderId > b_orderId) {
            return 1;
          }
          else {
            return 0;
          }
        }
      ));
    }
    else {
      // Success
      setInfoToastMessage('Success: Updated !');
      setTimeout(() => {
        setIsInfoToastVisible(false);
      }, 2000);
      let updateOrderIds = {};
      for (let i=0;i<updatedRecords.length;i++) {
        console.log('******* updateRecord: '+JSON.stringify(updatedRecords[i]));
        if (updatedRecords[i].linkType == 'webstorelink') {
          updateOrderIds[updatedRecords[i].linkId] = i;
        }
      }
      // Update displayPromotions Array
      displayWebstoreLinks.map((webstoreLink) => {
        webstoreLink.orderId = updateOrderIds[webstoreLink.linkId];
      });
      // Resort the displayPromotions Array
      setDisplayWebstoreLinks((prevDisplayWebstoreLinks) =>
        [...prevDisplayWebstoreLinks].sort((a, b) => {
          const a_orderId = a.orderId;
          const b_orderId = b.orderId;
          if (a_orderId < b_orderId) {
            return -1;
          }
          else if (a_orderId > b_orderId) {
            return 1;
          }
          else {
            return 0;
          }
        }
      ));
    }
  };

  useEffect(() => {
    console.log('H1');
    refreshWebstoreLinks();
  }, []);

  const refreshWebstoreLinks = async () => {
    const FUNCTION = 'refreshWebstoreLinks';
      
    setIsLoading(true);

    const webstoreLinksRes = await apiComms.getAllWebstoreLinks();
    console.log('RES: '+webstoreLinksRes);
    if (!webstoreLinksRes || webstoreLinksRes.isErr) {
      if (webstoreLinksRes) {
        alert('Sorry an error occured: '+webstoreLinksRes.errMsg);
      }
      else {
        alert('Sorry an Network error occured');
      }
    }
    else {
      let webstoreLinks = webstoreLinksRes.response.links;
      
      _enrichWebstoreLinks(webstoreLinks);
      let bannerLink = null;
      let linkToDelete = null;
      for (let i=0;i<webstoreLinks.length;i++) {
        const webstoreLink = webstoreLinks[i];
        if (webstoreLink.linkType == 'bannerlink') {
          bannerLink = webstoreLink;
          linkToDelete = i;
          break;
        }
      }
      if (bannerLink != null) {
        setDisplayBannerLink(bannerLink);
        webstoreLinks.splice(linkToDelete, 1);
      }

      // Sort webstoreLinks 03/Jan/2026
      webstoreLinks.sort((a, b) => {
        const a_orderId = a.orderId;
        const b_orderId = b.orderId;
        console.log('Comparing '+a_orderId+' against '+b_orderId);
        if (a_orderId < b_orderId) {
          return -1;
        }
        else if (a_orderId > b_orderId) {
          return 1;
        }
        else {
          return 0;
        }
      });



      setDisplayWebstoreLinks(webstoreLinks);
    }
    setIsLoading(false);
  };

  const _enrichWebstoreLinks = (webstoreLinks) => {
    const FUNCTION = '_enrichWebstoreLinks';
    for (let i=0;i<webstoreLinks.length;i++) {
      let webstoreLink = webstoreLinks[i];
      const displayFrom = dayjs((webstoreLink.displayFrom * 1000));
      const displayTo = dayjs((webstoreLink.displayTo * 1000));
      const now = dayjs();
      const isLive = (displayFrom.isBefore(now) && displayTo.isAfter(now));
      if (isLive) {
        webstoreLink.enrichedData = { displayStatus : 'LIVE' };
      }
      else {
        webstoreLink.enrichedData = { displayStatus : 'NOT LIVE' };
      }
    }
  };

  const handleCancelEditWebstoreLinkModalPress = () => {
    setIsEditWebstoreLinkModalVisible(false);
  };

  const handleCancelNewWebstoreLinkModalPress = () => {
    setIsAddWebstoreLinkModalVisible(false);
  };

  const handleUpdateWebstoreLinksEvent = () => {
    setIsAddWebstoreLinkModalVisible(false);
    refreshWebstoreLinks();
  };

  const handleEditWebstoreLinkItem = (webstoreLink) => {
    console.log('Edit WebstoreLink: '+JSON.stringify(webstoreLink));
    setEditWebstoreLinkItem(webstoreLink);
    setIsEditWebstoreLinkModalVisible(true);
  };

  const handleDeleteWebstoreLinkItem = (webstoreLink) => {
    setDeleteWebstoreLinkItem(webstoreLink);
    setIsDeleteWebstoreLinkModalVisible(true);
  };

  const handleConfirmDeleteWebstoreLinkItem = async (webstoreLink) => {

    setIsDeleteWebstoreLinkModalVisible(false);
    setIsLoading(true);

    const webstoreLinkId = webstoreLink.linkId;

    const res = await apiComms.deleteWebstoreLink(webstoreLinkId);

    setIsLoading(false);

    refreshWebstoreLinks();

  };

  const handleEditWebstoreLink = async (webstoreLink) => {
    const FUNCTION = 'handleEditWebstoreLink';

    //alert(JSON.stringify(webstoreLink));
    //return;

    // Make the AddOrEdit Modal Show it's refreshing view
    setIsAddOrEditWebstoreLinkModalRefreshing(true);


    const res = await apiComms.updateExistingWebstoreLink(
      webstoreLink.linkId,
      webstoreLink.title,
      webstoreLink.displayText,
      webstoreLink.linkUrl,
      webstoreLink.imageUrl,
      webstoreLink.displayFrom,
      webstoreLink.displayTo,
      'webstorelink'
    );            
    console.log('Response from updateWebstoreLink call: '+JSON.stringify(res));

    setIsAddOrEditWebstoreLinkModalRefreshing(false);
    setIsEditWebstoreLinkModalVisible(false);

    // Reload all our WebstoreLink Items
    refreshWebstoreLinks();
  };
  
    
    

  const handleAddNewWebstoreLink = async (webstoreLink) => {
    const FUNCTION = 'handleAddNewWebstoreLink';

    const res = await apiComms.addNewWebstoreLink(
      webstoreLink.title,
      webstoreLink.displayText,
      webstoreLink.linkUrl,
      webstoreLink.imageUrl,
      webstoreLink.displayFrom,
      webstoreLink.displayTo,
      'webstorelink'
    );            
    console.log('Response from addNewWebstoreLink call: '+JSON.stringify(res));

    setIsAddWebstoreLinkModalVisible(false);
    setIsAddOrEditWebstoreLinkModalRefreshing(false);
  
    // Reload all our WebstoreLink Items
    refreshWebstoreLinks();
  };

  const handleAddNewBannerLink = async (bannerLink) => {
    const FUNCTION = 'handleAddNewBannerLink';

    //alert(JSON.stringify(bannerLink));
    //return;

    // Make the AddOrEdit Modal Show it's refreshing view
    setIsAddOrEditBannerModalRefreshing(true);

    const res = await apiComms.addNewWebstoreLink(
      bannerLink.title,
      null, // No DisplayText for a Banner link
      bannerLink.linkUrl,
      bannerLink.imageUrl,
      bannerLink.displayFrom,
      bannerLink.displayTo,
      'bannerlink'
    );            
    console.log('Response from addNewWebstoreLink call: '+JSON.stringify(res));
    //alert('Response from addNewWebstoreLink call: '+JSON.stringify(res));

    setIsAddBannerModalVisible(false);
    setIsAddOrEditBannerModalRefreshing(false);
  
    // Reload all our WebstoreLink Items
    refreshWebstoreLinks();
    
  };

  const handleEditBannerLink = () => {
    setEditBannerItem(JSON.parse(JSON.stringify(displayBannerLink)));
    setIsEditBannerModalVisible(true);
  };
  
  const handleProcessEditBannerLinkUpdate = async (bannerLink) => {
    const FUNCTION = 'handleProcessEditBannerLinkUpdate';

    // Make the AddOrEdit Modal Show it's refreshing view
    setIsAddOrEditWebstoreLinkModalRefreshing(true);

    const res = await apiComms.updateExistingWebstoreLink(
      bannerLink.linkId,
      bannerLink.title,
      null, // No display text for banner link
      bannerLink.linkUrl,
      bannerLink.imageUrl,
      bannerLink.displayFrom,
      bannerLink.displayTo,
      'bannerlink'
    );            
    console.log('Response from handleProcessEditBannerLinkUpdate call: '+JSON.stringify(res));

    setIsAddOrEditWebstoreLinkModalRefreshing(false);
    setIsEditBannerModalVisible(false);

    // Reload all our WebstoreLink Items
    refreshWebstoreLinks();
  };

  const handleDeleteBannerLink = (bannerItem) => {
    setDeleteBannerLink(bannerItem);
    setIsDeleteBannerLinkModalVisible(true);
  };

  const handleConfirmDeleteBannerLink = async (bannerItem) => {

    setIsDeleteBannerLinkModalVisible(false); 
    setIsLoading(true);
  
    const bannerId = bannerItem.linkId;
  
    const res = await apiComms.deleteWebstoreLink(bannerId);
 
    setDisplayBannerLink(null); 
    setIsLoading(false);
  };


  return (
    <>
      { isAddWebstoreLinkModalVisible ? (
        <WebstoreLinkAddOrEditModal handleCancelPress = { () => { setIsAddWebstoreLinkModalVisible(false); }} handleSubmitButtonPress = { handleAddNewWebstoreLink } modalTitle='ADD NEW STORE LINK' modalKeyword='WebstoreLink' isLinkUrl = { true } submitButtonText='Add New' isRefreshing = { isAddOrEditWebstoreLinkModalRefreshing } imageAspect={1.33} isDisplayText = { true } />
      ) : null }
      { isEditWebstoreLinkModalVisible ? (
        <WebstoreLinkAddOrEditModal handleCancelPress = { () => { setIsEditWebstoreLinkModalVisible(false); }} handleSubmitButtonPress = { handleEditWebstoreLink } modalTitle='EDIT STORE LINK' modalKeyword='WebstoreLink' isLinkUrl = { true } submitButtonText='Update' isRefreshing = { isAddOrEditWebstoreLinkModalRefreshing } existingWebstoreLink = { editWebstoreLinkItem } imageAspect={1.33} isDisplayText = { true } />
      ) : null }
      { isDeleteWebstoreLinkModalVisible ? (
        <DeletePromotionItemModal promotion = { deleteWebstoreLinkItem } modalTitle='DELETE STORE LINK' modalKeyword='WebstoreLink' isLinkUrl = { true } handleCancelPress = { () => { setIsDeleteWebstoreLinkModalVisible(false); }} handleDeleteButtonPress = { (webstoreLink) => { handleConfirmDeleteWebstoreLinkItem(webstoreLink); }} imageAspect={1.33} isDisplayText = { true } />
      ) : null }



      { isAddBannerModalVisible ? (
        <WebstoreLinkAddOrEditModal handleCancelPress = { () => { setIsAddBannerModalVisible(false); }} handleSubmitButtonPress = { handleAddNewBannerLink } modalTitle='ADD NEW BANNER' modalKeyword='Banner' isLinkUrl = { true } submitButtonText='Add New' isRefreshing = { isAddOrEditBannerModalRefreshing } imageAspect={3.55} isDisplayText = { false } />
      ) : null }

      { isEditBannerModalVisible ? (
        <WebstoreLinkAddOrEditModal handleCancelPress = { () => { setIsEditBannerModalVisible(false); }} handleSubmitButtonPress = { handleProcessEditBannerLinkUpdate } modalTitle='EDIT BANNER' modalKeyword='Banner' isLinkUrl = { true } submitButtonText='Update' isRefreshing = { isAddOrEditBannerModalRefreshing } existingWebstoreLink = { editBannerItem } imageAspect={3.55} isDisplayText = { false } />
      ) : null }

      { isDeleteBannerLinkModalVisible ? (
        <DeletePromotionItemModal promotion = { deleteBannerLink }  modalTitle='DELETE BANNER' modalKeyword='Banner' isLinkUrl = { true } handleCancelPress = { () => { setIsDeleteBannerLinkModalVisible(false); }} handleDeleteButtonPress = { (bannerItem) => { handleConfirmDeleteBannerLink(bannerItem); }} isDisplayText = { false } />
      ) : null }

      <TopNavBar handleUpdate = { props.handleUpdate } activeRoute = { props.activeRoute } />
      <SideNavBar handleUpdate = { props.handleUpdate } activeRoute = { props.activeRoute } />
      <div style={{ marginLeft: isMobile ? MOBILE_CONTENT_MARGIN_LEFT : DESKTOP_CONTENT_MARGIN_LEFT, marginRight : 10, marginTop : 0, paddingTop : 45 }}>
        <h1 style={{ fontSize: 18, fontWeight : 'bold', paddingTop : 20 }}>Offers & WebstoreLinks > Webstore Links</h1>


        { showInfoBox ? (
          <div style={{ marginTop : 20 }} className="alert alert-primary lert-dismissible fade show" role="alert">
            <h4 className="alert-heading">About Webstore Links</h4>
            <p>Webstore links are visible on the Shop view in the Petstop App.  The top big & wide banner link has pride of place in the Shop App view and takes up the full width at the top of the view and, unlike the smaller store links, does not show any accompanying text.</p>
            <button style={{ position : 'absolute', top : 10, right : 10 }} type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={ () => { setShowInfoBox(false); }} onPress={ () => { setShowInfoBox(false); }}></button>
          </div>
        ) : null }

          { isLoading ? (
            <Refreshing message='Loading WebstoreLinks...' />
          ) : null }

          { !isLoading ? (
            <>
              <h2 style={{ fontSize: 16, fontWeight : 'bold', paddingTop : 20, marginLeft : 10 }}>Banner Store Link</h2>
              <div style={{ height : '1px', width : '100%', backgroundColor : '#cccccc', marginTop : 0, marginbottom : 10, marginLeft : 10, marginRight : 10 }} />


              { displayBannerLink == null ? (

                <div style={{ flexDirection : 'column', height : 140, backgroundColor : '#eee', width : 497, borderStyle : 'dashed', borderWidth : 1, borderRadius : 10, marginLeft : 10, marginTop : 20, padding : 0, alignItems : 'center', justifyContent : 'center', display : 'flex', overflow : 'hidden', cursor : 'pointer' }} onClick = { () => { setIsAddBannerModalVisible(true); }}>
                <p style={{ flexGrow : 1, display : 'flex', alignItems : 'center', justifyContent : 'center' }}>NO BANNER LINK</p>
                <div style={{ height : 40, backgroundColor : '#8d949e', paddingLeft: 10, paddingRight : 10, display : 'flex', alignItems : 'center', justifyContent : 'space-between', width : '100%' }}>
                  <div style={{ color : 'white', fontSize: 18, fontWeight : 'bold' }}>Add Banner</div>
                  <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
                    <div><IoMdAddCircleOutline style={{ color : 'white', fontSize: 26, paddingTop : 4 }} /></div>
                  </div>
                </div>
              </div>

            ) : (
              <div style={{ margin : 10, borderRadius: 10, overflow : 'hidden', backgroundColor : '#eee', width : 720 }}>
                <div style={{ backgroundColor : '#eee', margin : 0, padding : 0 }}><img style={{ objectFit : 'cover', display: 'block', width : '100%' }} src={ displayBannerLink.imageUrl } /></div>
                
                <div style={{ height : 40, backgroundColor : '#8d949e', paddingLeft: 10, paddingRight : 10, paddingTop : 5, paddingBottom : 5, display : 'flex', alignItems : 'center', justifyContent : 'space-between', width : '100%' }}>
                  <div style={{ color : 'white', fontSize: 18, fontWeight : 'bold' }}>{ displayBannerLink.enrichedData.displayStatus }</div>
                  <div style={{ display : 'flex', flexDirection : 'row', alignItems : 'center' }}>
                    <div style={{ cursor : 'pointer' }} onClick={ () => { handleEditBannerLink(displayBannerLink); }}><IoMdSettings style={{ color : 'white', fontSize: 26, paddingTop : 4 }} /></div>
                    <div style={{ cursor : 'pointer' }} onClick={ () => { handleDeleteBannerLink(displayBannerLink); }}><FaTrashAlt style={{ color : 'white', fontSize: 22, paddingTop : 4 }} /></div>
                  </div>
                </div>
              </div>
            ) }

            <h2 style={{ fontSize: 16, fontWeight : 'bold', paddingTop : 20, marginLeft : 10 }}>Store Links</h2>
            <div style={{ height : '1px', width : '100%', backgroundColor : '#cccccc', marginTop : 0, marginbottom : 10, marginLeft : 10, marginRight : 10 }} />
            
            <div style={{ width : '100%' }}>

              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
              >
                <SortableContext items={displayWebstoreLinks.map((item) => item.linkId)} strategy={rectSortingStrategy}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection : 'column',
                      gap: 5,
                      padding: 0,
                    }}
                  >
                    { displayWebstoreLinks.map((webstoreLink, i) => {
                      const linkId = webstoreLink.linkId;
                      console.log('XXXXXXXXXXXX Link Id: '+linkId);
                      return (
                        <WebstoreLinkCardComponent
                          key = { linkId }
                          id = { linkId }
                          webstoreLink = { webstoreLink }
                          handleEditWebstoreLinkItem = { handleEditWebstoreLinkItem }
                          handleDeleteWebstoreLinkItem = { handleDeleteWebstoreLinkItem }
                          totalItems = { displayWebstoreLinks.length }
                        />
                      );
                    })}
                  </div>
                </SortableContext>
              </DndContext>

            </div>
            <div style={{ height : 100 }} />
            <button
              type="button"
              className="btn btn-info position-fixed bottom-0 end-0 m-4 rounded-circle"
              style={{ width : 56, height : 56 }}
              onClick = { () => { setIsAddWebstoreLinkModalVisible(true); }}
              onPress = { () => { setIsAddWebstoreLinkModalVisible(true); }}
            >
            +
            </button>
          </>
        ) : null }

        
      </div>
    
      { isInfoToastVisible ? (
        <div className="toast-container position-fixed bottom-0 end-0 p-3">
          <div className="toast show text-bg-info text-white">
            <div className="d-flex">
              <div className="toast-body">
                { infoToastMessage }
              </div>
              <button type="button" className="btn-close me-2 m-auto bg-white" data-bs-dismiss="toast" aria-label="Close" onClick = { () => { setIsInfoToastVisible(false); }} onPress = { () => { setIsInfoToastVisible(false); }}></button>
            </div>
          </div>
        </div>
      ) : null }

    </>
  );

};

export default WebstoreLinks;
